import { app } from '../../../../../app';

app.component('companyManageApplicationIntegrationDevelopersScimProvInstructions', {
    bindings: {
    },
    templateUrl: require('./scim-prov-instructions.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/integration-developers/scim-prov-instructions/scim-prov-instructions.component.js